'use client';
import React, { useEffect } from 'react';

function Navbar() {
  function handleScroll() {
    const bodyScroll = window.scrollY;
    const navbar = document.querySelector('.navbar');

    if (bodyScroll > 300) navbar.classList.add('nav-scroll');
    else navbar.classList.remove('nav-scroll');
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  function handleToggleNav() {
    if (
      document
        .querySelector('.navbar .navbar-collapse')
        .classList.contains('show')
    ) {
      document
        .querySelector('.navbar .navbar-collapse')
        .classList.remove('show');
    } else if (
      !document
        .querySelector('.navbar .navbar-collapse')
        .classList.contains('show')
    ) {
      document.querySelector('.navbar .navbar-collapse').classList.add('show');
    }
  }
  function handleNavClick(e) {
    const href = e.currentTarget.getAttribute('href');
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        // Cerrar el menú móvil si está abierto
        const navbarCollapse = document.querySelector('.navbar .navbar-collapse');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
          navbarCollapse.classList.remove('show');
        }

        // Obtener la altura real del navbar
        const navbar = document.querySelector('.navbar');
        let navbarHeight = 0;
        if (navbar) {
          const navbarRect = navbar.getBoundingClientRect();
          // Si el navbar está fijo (nav-scroll), usar su altura
          // Si está en posición absoluta, usar altura mínima para evitar solapamiento
          if (navbar.classList.contains('nav-scroll')) {
            navbarHeight = navbarRect.height || 80;
          } else {
            // Cuando está en posición absoluta, usar un pequeño offset para evitar solapamiento
            navbarHeight = navbarRect.height > 0 ? navbarRect.height : 0;
          }
        }

        // Calcular la posición de la sección objetivo relativa al documento
        const rect = targetElement.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const elementTop = rect.top + scrollTop;
        const offsetPosition = elementTop - navbarHeight;

        // Usar scrollIntoView con opciones para mejor compatibilidad
        // pero primero ajustar manualmente el scroll para tener control del offset
        const finalPosition = Math.max(0, offsetPosition);

        // Intentar usar ScrollSmoother si está disponible (se carga dinámicamente)
        if (typeof window !== 'undefined' && window.ScrollSmoother) {
          try {
            const smoother = window.ScrollSmoother.get();
            if (smoother) {
              smoother.scrollTo(finalPosition, true);
              return;
            }
          } catch (e) {
            // Continuar con scroll nativo si falla
          }
        }

        // Scroll nativo suave
        window.scrollTo({
          top: finalPosition,
          behavior: 'smooth'
        });
      }
    }
  }
  return (
    <nav className="navbar navbar-expand-lg bord blur">
      <div className="container o-hidden">
        <a className="logo icon-img-100" href="#inicio" onClick={handleNavClick}>
          <img src="/assets/imgs/logo-light.png" alt="logo" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleToggleNav}
        >
          <span className="icon-bar">
            <i className="fas fa-bars"></i>
          </span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" href="#nosotros" onClick={handleNavClick}>
                <span className="rolling-text">Nosotros</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#cultura" onClick={handleNavClick}>
                <span className="rolling-text">Cultura</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#experiencias" onClick={handleNavClick}>
                <span className="rolling-text">Experiencias</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#productos" onClick={handleNavClick}>
                <span className="rolling-text">Catálogo</span>
              </a>
            </li>
          </ul>
        </div>

        <div className="contact-button">
          <a
            href="https://wa.me/573115742189?text=Hola, me interesa conocer más sobre sus productos"
            target="_blank"
            rel="noopener noreferrer"
            className="butn butn-sm butn-bg main-colorbg"
          >
            <span className="text">Contacto</span>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
